module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-3-thumb.a3dab2e0.png";